"use client";

import ErrorResultCard from "@/components/ErrorResultCard";

// 한국어 라우트의 에러 바운더리. /en 은 [locale]/error.tsx 가 먼저 잡는다.
// 루트 레이아웃 자체가 죽는 크래시는 global-error.tsx 가 처리.
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ErrorResultCard locale="ko" error={error} reset={reset} />;
}
